import React, { useState } from "react";
import axios from "axios";
import Reasons from "./Reasons";

export default function ApproveForm(props) {
  const [name, setName] = useState("");
  const [reason, setReason] = useState("");
  const [showList, setShowList] = useState(false);

  const handleReasonClick = () => {
    setShowList(!showList);
  };

  const handleNamePress = (e) => {
    setName(e.target.value);
  };

  const handleReasonChange = (reason) => {
    setReason(reason);
    setShowList(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (name.length === 0 || reason.length === 0) {
      alert("All fields required");
    } else {
      let data = {
        id: props.id,
        orderId: props.orderId,
        name: name,
        reason: reason,
      };
      console.log(data);
      await axios
        .post(
          "https://nitrous.rt-itservices.co.uk/packers/refund/status/approved",
          {
            data,
          }
        )
        .then((response) => {
          console.log(response.data);
        })
        .catch((e) => console.log(e));
    }

    setName("");
    setReason("");
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  return (
    <form className="mt-4 mb-3">
      <div>
        <h4>Approval Form</h4>
        <div className="row">
          <div className="col-2">Name</div>
          <div className="col-10">Reason</div>
        </div>
        <div className="row">
          <div className="col-2">
            <input
              type="text"
              className="form-control"
              placeholder="Name"
              value={name}
              onChange={handleNamePress}
            />
          </div>
          <div className="col-10">
            <input
              style={{ color: "transparent", textShadow: "0 0 0 #000" , cursor:"pointer"}}
              type="text"
              className="form-control rounded-0"
              placeholder="Reason"
              value={reason}
              onClick={handleReasonClick}
            />
            {showList ? <Reasons clicked={handleReasonChange}/> : null}
          </div>
        </div>
        <div
          className="btn btn-success mt-3 mb-3 float-right"
          onClick={handleSubmit}>
          Submit
        </div>
      </div>
    </form>
  );
}
